<template>
  <div class="login">
    <div class="login__container">
      <img src="/static/images/logo.png" alt="Logotipo CMS" class="login__logo">
      <h1 class="login__title">¿Olividó su contraseña</h1>
      <p class="login__text">Enviaremos un código de recuperación a su dirección de correo electrónico, utilicelo para generar una nueva contraseña, siga las indicaciones en el mensaje.</p>
      <form class="form" @submit.prevent="recovery">
        <div class="form__fieldset">
          <div class="form__container">
            <label for="email" class="form__label form__label--hidden">Correo Electrónico</label>
            <input type="text" class="form__input" name="email" id="email" v-model="access.email" placeholder="Correo electrónico" v-validate="validation.email">
            <span v-show="errors.has('email')" class="form__alert" v-text="errors.first('email')"></span>
          </div>
        </div>
        <input type="submit" class="btn btn__action btn--regular" value="Enviar código">
        <router-link :to="{name: 'signIn'}" class="btn btn__transparent btn--regular">Volver al inicio de sesión</router-link>
        <router-link :to="{name: 'resetLogin'}" class="btn btn__transparent btn--regular">Ya tengo mi código de recuperación</router-link>
      </form>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
export default {
  name: 'recoveryLogin',
  mixins: [
    httpService
  ],
  data: function () {
    return {
      access: {
        email: null
      },
      validation: {
        email: 'required|email'
      }
    }
  },
  methods: {
    recovery: function () {
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'recovery',
                element: this.access
              }
              this.post(httpRequest)
                .then(
                  recovery => {
                   this.$router.push({name: 'resetLogin'})
                   this.$store.commit('notificate', {
                      title: 'CÓDIGO ENVIADO',
                      text: 'Su código de recuperación ha sido enviado a la dirección de correo electrónico proporcionada.',
                      type: 'success'
                    })
                  }
                ).catch(
                  () => {
                    this.$store.commit('notificate', {
                      title: 'ERROR DE VALIDACIÓN',
                      text: 'Ha ocurrido un problema al tratar de validar sus datos, por favor, revise su correo',
                      type: 'warn'
                    })
                  }
                )
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "../../assets/sass/components/_login"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/login/recovery.vue